import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

// export const GridContainer = styled.div`
// 	display: grid;
// 	grid-template-columns: 49% 49%;
// 	gap: 10px;
// 	background-color: ${colors.grey1};
// 	padding: 0.5%;
// `;
export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const KpiGridContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 1260px;
	padding: 0 5% 0 5%;
	margin-left: auto;
	margin-right: auto;
`;
